import React, { useState } from 'react';
import './ChangePassword.css';

const BASE = 'https://fotileams.com/api';

export default function ChangePassword({ employee, token, onSuccess }) {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw]         = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');

  const handleSubmit = async () => {
    setError('');
    if (!currentPw) { setError('Enter your temporary password'); return; }
    if (!newPw)     { setError('Enter a new password'); return; }
    if (newPw.length < 6) { setError('New password must be at least 6 characters'); return; }
    if (newPw !== confirmPw) { setError('Passwords do not match'); return; }
    if (newPw === currentPw) { setError('New password must be different from the temporary one'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${BASE}/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          employee_id:       employee?.employee_id,
          current_password:  currentPw,
          old_password:      currentPw,
          new_password:      newPw,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Failed to change password'); return; }
      onSuccess();
    } catch { setError('Connection error — try again'); }
    finally { setLoading(false); }
  };

  const getFirstName = (name) => name?.trim().split(' ')[0] || '';

  return (
    <div className="cp-root">
      <div className="cp-card">
        <div className="cp-logo">
          <img src="https://fotileams.com/fotile-logo-red.png" alt="Fotile" className="cp-logo-img" />
        </div>

        <div className="cp-icon">🔐</div>
        <h1 className="cp-title">Set Your Password</h1>
        <p className="cp-sub">
          Welcome, <strong>{getFirstName(employee?.full_name)}</strong>!
          Your account was set up with a temporary password.
          Please set a new personal password to continue.
        </p>

        {error && <div className="cp-error">{error}</div>}

        <div className="cp-form">
          <div className="cp-field">
            <label>Temporary Password</label>
            <input type="password"
              placeholder="Enter the password HR gave you"
              value={currentPw}
              onChange={e => setCurrentPw(e.target.value)} />
          </div>

          <div className="cp-field">
            <label>New Password</label>
            <input type="password"
              placeholder="At least 6 characters"
              value={newPw}
              onChange={e => setNewPw(e.target.value)} />
          </div>

          <div className="cp-field">
            <label>Confirm New Password</label>
            <input type="password"
              placeholder="Repeat your new password"
              value={confirmPw}
              onChange={e => setConfirmPw(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
          </div>

          <div className="cp-strength">
            {newPw.length > 0 && (
              <div className="cp-strength-bar">
                <div className={`cp-strength-fill cp-strength-${
                  newPw.length < 6 ? 'weak' :
                  newPw.length < 10 ? 'medium' : 'strong'
                }`} style={{ width: `${Math.min(100, (newPw.length / 12) * 100)}%` }} />
              </div>
            )}
            {newPw.length > 0 && (
              <span className="cp-strength-label">
                {newPw.length < 6 ? '⚠ Too short' :
                 newPw.length < 10 ? '👍 Good' : '💪 Strong'}
              </span>
            )}
          </div>

          <button className="cp-btn" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Saving…' : 'Set Password & Continue'}
          </button>
        </div>

        <p className="cp-note">
          Your password is private — HR cannot see it after you change it.
        </p>
      </div>
    </div>
  );
}